import { render, staticRenderFns } from "./ClienteCliente.vue?vue&type=template&id=7ae28f49&scoped=true&"
import script from "./ClienteCliente.vue?vue&type=script&lang=js&"
export * from "./ClienteCliente.vue?vue&type=script&lang=js&"
import style0 from "./ClienteCliente.vue?vue&type=style&index=0&id=7ae28f49&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae28f49",
  null
  
)

export default component.exports